import { Menu, alpha, styled } from '@mui/material';
import { scrollbarStyle4 } from '../../../../../../../styles/scrollbarStyles';
import { spaceCadet } from '../../../../../../../utils/colors';

const StyledMenu = styled(Menu)(() => ({
  width: 300,
  maxHeight: 400,
  '& .MuiPaper-root': {
    ...scrollbarStyle4,

    '& .MuiList-root': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
      padding: 0,
      '& .MuiMenuItem-root': {
        padding: '8px 16px',
        borderBottom: `1px solid ${alpha(spaceCadet[300], 0.3)}`,
        fontSize: 14,
        lineHeight: '20px',
      },
    },
  },
}));

export default StyledMenu;
